export const SCALE_STYLING_OPTIONS = {
  scaleType: ['scaleline', 'scalebar'],
  scaleUnits: [
    {name: 'degrees', value: 'degrees'},
    {name: 'us inch', value: 'us'},
    {name: 'nautical mile', value: 'nautical'},
    {name: 'metric', value: 'metric'},
  ],
  scaleBarSteps: [2, 4, 6, 8],
};
